module.exports = __webpack_public_path__ + "static/img/1393_phase_function_Paper_Points.7100d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1393_phase_function_Paper_Points.png
// module id = wAvr
// module chunks = 0